import React from 'react';
import { Card } from '../ui/card';

/** Dashboard-only surface; does not change shared cards or semantic status colors. */
export default function DashboardPanel({ className = '', ...props }) {
  return (
    <Card
      className={`rounded-2xl border border-slate-200 bg-white text-slate-950 shadow-none ${className}`}
      {...props}
    />
  );
}
